import type { ReaderBlock } from '@bookclub/shared';

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;
const EMPTY_PARAGRAPH_PATTERN = /<p(?:\s[^>]*)?>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi;

function escapeHtml(text: string) {
  return text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

export function normalizeRichTextHtml(text: string) {
  if (!text.trim()) return '';
  if (HTML_TAG_PATTERN.test(text)) {
    return text.replace(EMPTY_PARAGRAPH_PATTERN, '').trim();
  }

  return text
    .trim()
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.trim())
    .filter((paragraph) => paragraph.length > 0)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br />')}</p>`)
    .join('');
}

export function getMediaCaptionText(block: ReaderBlock): string | null {
  const caption = block.payload['caption'];
  if (typeof caption !== 'string') return null;

  const trimmed = caption.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function MediaCaption({
  caption,
  className = '',
  testId,
}: {
  caption: string | null | undefined;
  className?: string;
  testId?: string;
}) {
  const normalizedCaption = caption ? normalizeRichTextHtml(caption) : '';
  if (!normalizedCaption) return null;

  return (
    <div
      data-testid={testId}
      className={[
        'reader-prose text-[13px] leading-[1.55] text-[rgba(26,26,26,0.56)]',
        className,
      ].join(' ')}
      dangerouslySetInnerHTML={{ __html: normalizedCaption }}
    />
  );
}
